import { connect } from 'react-redux'
import AddressFormComponent from '../components/AddressForm'
import {
  fetchAllStates,
  addAddress,
} from '../actions/ApiReqest'
import {
  switchToListMode,
  switchToEditMode,
  switchToNewMode,
  onTextFieldChange,
  onSelectChange,
  updateCountryCode,
  resetState,
  validateAllFields,
  clearAddAddressError,
  clearValidationErrorMessage,
} from '../actions'

const mapStateToProps = (state) => ({
  addressList: state.address.list,
  countries: state.address.allCountries,
  states: state.address.states,
  mode: state.address.mode,
  formData: state.address.selectedAddress,
  merchantCountry: state.merchant.home_country,
  countryCode: state.address.countryCode,
  formErrors: state.address.errors,
  showAddressErrorMessage: state.address.add.error,
  addressErrorMessage: state.address.add.message,
})

const mapDispatchToProps = (dispatch) => ({
  switchToEditMode: () => dispatch(switchToEditMode()),
  switchToNewMode: () => dispatch(switchToNewMode()),
  onTextFieldChange: (event) => {
    dispatch(onTextFieldChange(event))
  },
  onSelectChange: (value, field) => {
    dispatch(onSelectChange(value, field))
  },
  setPhoneCode: (allCountries, merchantCountry) => {
    const country = allCountries.find((c) => (c.code === merchantCountry))
    dispatch(updateCountryCode(country.phone_code))
  },
  onCancel: () => {
    dispatch(switchToListMode())
    dispatch(clearAddAddressError())
    dispatch(clearValidationErrorMessage())
  },
  addAddress: async () => {
    await dispatch(validateAllFields())
    dispatch(addAddress())
  },
  fetchAllStates: (country) => {
    dispatch(fetchAllStates(country))
  },
  resetState: () => {
    dispatch(resetState())
  },
})

/*
const mergePorps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  addAddress: () => dispatchProps.addAddress(stateProps),
})
*/

const AddressForm = connect(mapStateToProps, mapDispatchToProps)(AddressFormComponent)

export default AddressForm
